// ResponsiveHeader.jsx - モバイル対応ヘッダーコンポーネント

import React from 'react';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';

/**
 * レスポンシブクイズヘッダーコンポーネント
 * モバイル表示時にレイアウトを最適化
 */
const ResponsiveHeader = ({ 
  title, 
  onClose, 
  timerComponent = null,
  enableResponsive = true  // 段階的移行用フラグ
}) => {
  if (!enableResponsive) {
    // 既存のレイアウトを完全に保持
    return (
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-purple-800">
          {title}
        </h2>
        <div className="flex items-center gap-4">
          {timerComponent}
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
            aria-label="モーダルを閉じるボタン"
          >
            <X size={24} />
          </button>
        </div>
      </div>
    );
  }

  // レスポンシブ改善版
  return (
    <div className="mb-4">
      {/* モバイル: 縦積み、デスクトップ: 横並び */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-4">
        {/* タイトル部分 */}
        <h2 className="text-lg sm:text-xl font-semibold text-purple-800 line-clamp-2 sm:line-clamp-1 pr-2 sm:pr-0">
          {title}
        </h2>
        
        {/* コントロール部分 */}
        <div className="flex items-center justify-between sm:justify-end gap-3 sm:gap-4 flex-shrink-0">
          {timerComponent && (
            <div className="flex-shrink-0">
              {timerComponent}
            </div>
          )}
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 p-1 flex-shrink-0"
            aria-label="モーダルを閉じるボタン"
          >
            <X size={24} />
          </button>
        </div>
      </div>
    </div>
  );
};

ResponsiveHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  timerComponent: PropTypes.node,
  enableResponsive: PropTypes.bool
};

export default ResponsiveHeader; 